export default __webpack_public_path__ + "static/media/regulatory--end-of-trams-and-buses-only--g1.25dd9871.png";